import { PROSPECT_SUBMISSION_STATUS } from '../../constants';

export const ENGAGE_AVAILABILITY = {
  NONE: 'none',
  PENDING: 'pending',
  APPROVED: 'approved',
};

export const ENGAGE_COPY = {
  [ENGAGE_AVAILABILITY.NONE]: 'You need to add a prospect and get it approved by the client before you can use Engage.',
  [ENGAGE_AVAILABILITY.PENDING]:
    'You don’t have an approved prospect yet. Your submitted prospects are waiting for client approval. Once one is approved, you can start using Engage.',
  [ENGAGE_AVAILABILITY.APPROVED]:
    'Create and refine prospect messages using your company profile, conversation context, and AI support. Generate introductions or replies, and iterate until it’s ready to send.',
};

export const asId = (value) => String(value?._id || value || '');

export const opportunityClientId = (product, company) => {
  const value = company?.client?._id || company?.client || product?.company?.client?._id || product?.company?.client;
  return value ? String(value) : '';
};

export const opportunityProgramId = (product) => (product?._id ? String(product._id) : '');

export const matchesOpportunity = (row, clientId, programId) =>
  asId(row?.client) === String(clientId) && asId(row?.program) === String(programId);

export const getEngageAvailability = (prospects, clientId, programId) => {
  if (!clientId || !programId) return ENGAGE_AVAILABILITY.NONE;

  const rows = (prospects || []).filter((row) => matchesOpportunity(row, clientId, programId));
  if (rows.some((row) => row.status === PROSPECT_SUBMISSION_STATUS.APPROVED)) {
    return ENGAGE_AVAILABILITY.APPROVED;
  }
  if (rows.some((row) => row.status === PROSPECT_SUBMISSION_STATUS.PENDING)) {
    return ENGAGE_AVAILABILITY.PENDING;
  }
  return ENGAGE_AVAILABILITY.NONE;
};
